var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeakLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67772 12.2724L6.83066 8.29844L7.41779 9.38931V9.36986L8.02454 0L0 14.8632H7.06549L7.24166 12.2724H4.67772Z",
    fill: "#C63D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02448 0L7.41773 9.36986L8.72909 6.97382L11.5866 12.2724H7.2416L7.06543 14.8632H16.049L8.02448 0Z",
    fill: "#96324B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakLogoSmall);
export default __webpack_public_path__ + "static/media/peak-logo-small.a8560985afba8e3da871958b6c4b82f7.svg";
export { ForwardRef as ReactComponent };